import React from 'react';
import './CascadeUpdateDialog.css';

function CascadeUpdateDialog({
    isOpen,
    usages,
    onConfirm,
    onCancel,
    loading = false
}) {
    if (!isOpen) return null;

    const totalUsages = usages?.total_count || 0;
    const lockedCount = usages?.locked_count || 0;
    const unlockedCount = usages?.unlocked_count || 0;

    return (
        <div className="cascade-dialog-overlay" onClick={onCancel}>
            <div className="cascade-dialog" onClick={(e) => e.stopPropagation()}>
                <div className="cascade-dialog-header">
                    <h2>⚠️ Mise à jour en cascade</h2>
                </div>

                <div className="cascade-dialog-content">
                    {totalUsages === 0 ? (
                        <div className="cascade-info">
                            <p>Ce modèle n'est utilisé dans aucune signature.</p>
                            <p>Vous pouvez sauvegarder sans problème.</p>
                        </div>
                    ) : (
                        <>
                            <div className="cascade-warning">
                                <p>
                                    <strong>Ce modèle est utilisé dans {totalUsages} signature{totalUsages > 1 ? 's' : ''}.</strong>
                                </p>
                                <p>
                                    Si vous confirmez l'enregistrement, les modifications seront
                                    automatiquement répercutées sur toutes les signatures qui utilisent ce modèle.
                                </p>
                            </div>

                            <div className="cascade-stats">
                                <div className="cascade-stat">
                                    <span className="stat-number success">{unlockedCount}</span>
                                    <span className="stat-label">seront mises à jour</span>
                                </div>
                                {lockedCount > 0 && (
                                    <div className="cascade-stat">
                                        <span className="stat-number warning">{lockedCount}</span>
                                        <span className="stat-label">verrouillée{lockedCount > 1 ? 's' : ''} (ignorée{lockedCount > 1 ? 's' : ''})</span>
                                    </div>
                                )}
                            </div>

                            {usages?.usages && usages.usages.length > 0 && (
                                <div className="cascade-usages-list">
                                    <p className="usages-title">Signatures affectées :</p>
                                    <ul>
                                        {usages.usages.slice(0, 5).map((usage) => (
                                            <li key={usage.id} className={usage.is_locked ? 'locked' : ''}>
                                                {usage.signature_name}
                                                {usage.is_locked && <span className="locked-badge">🔒 Verrouillée</span>}
                                            </li>
                                        ))}
                                        {usages.usages.length > 5 && (
                                            <li className="more-usages">
                                                ... et {usages.usages.length - 5} autre{usages.usages.length - 5 > 1 ? 's' : ''}
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            )}
                        </>
                    )}
                </div>

                <div className="cascade-dialog-footer">
                    <button
                        className="btn btn-secondary"
                        onClick={onCancel}
                        disabled={loading}
                    >
                        Annuler
                    </button>
                    <button
                        className="btn btn-primary"
                        onClick={onConfirm}
                        disabled={loading}
                    >
                        {loading ? 'Enregistrement...' : totalUsages > 0 ? `Confirmer et mettre à jour ${unlockedCount} signature${unlockedCount > 1 ? 's' : ''}` : 'Sauvegarder'}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default CascadeUpdateDialog;
